import apiSportEvents from '@/api/sports-events'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteSportEventStart: '[delete sport event] Delete sport event start',
  deleteSportEventSuccess: '[delete sport event] Delete sport event success',
  deleteSportEventFailure: '[delete sport event] Delete sport event failure'
}

export const actionTypes = {
  deleteSportEvent: '[delete sport event] Delete sport event'
}

const mutations = {
  [mutationTypes.deleteSportEventStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteSportEventSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteSportEventFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteSportEvent](context, {id}) {
    context.commit(mutationTypes.deleteSportEventStart)
    return new Promise(resolve => {
      apiSportEvents
        .deleteSportEvent(id)
        .then(response => {
          context.commit(mutationTypes.deleteSportEventSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteSportEventFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
